class CartTerms extends HTMLElement {
  constructor() {
    super();
    this.terms = this.querySelector('#accept-terms');

    // Bind so `this` inside handleInputChange is the component instance
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({ key: 'component-cart-terms' });
    if (!this.terms) return;

    this.terms.addEventListener('change', this.handleInputChange);
    this.syncCheckoutState();
  }

  disconnectedCallback() {
    if (this.terms) this.terms.removeEventListener('change', this.handleInputChange);
    if (this._checkoutClickHandler && this.checkoutButton) {
      this.checkoutButton.removeEventListener('click', this._checkoutClickHandler);
    }
  }

  get checkoutButton() {
    return this.nextElementSibling;
  }

  syncCheckoutState() {
    const btn = this.checkoutButton;
    if (!btn) return;

    // If you must enforce an ID:
    if (btn.id !== 'Cart-Checkout') return;

    const checked = !!this.terms?.checked;
    btn.toggleAttribute('disabled', !checked);
    btn.setAttribute('aria-disabled', String(!checked));
  }

  handleInputChange(e) {
    const btn = this.checkoutButton;
    if (!btn) return;

    if (btn.id !== 'Cart-Checkout') return;

    if (e.target.checked) {
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', 'false');
      this.ensureCheckoutHandler(btn);
    } else {
      btn.setAttribute('disabled', 'true');
      btn.setAttribute('aria-disabled', 'true');
    }
  }

  ensureCheckoutHandler(btn) {
    // Prevent stacking multiple click listeners on repeated check/uncheck
    if (this._checkoutClickHandler) return;

    this._checkoutClickHandler = (e) => {
      if (!this.terms?.checked) {
        e.preventDefault();
        e.stopPropagation();
        this.syncCheckoutState();
        return;
      }
      window.location.href = '/checkout';
    };

    btn.addEventListener('click', this._checkoutClickHandler);
  }
}

customElements.define('cart-terms', CartTerms);
